export interface GetBibliographyFullIdRequest {
  id: number
  collectionNo: string
}

export function GetBibliographyFullIdRequestToJSON(
  value: GetBibliographyFullIdRequest
): any {
  return {
    id: value.id !== 0 ? value.id : undefined,
    collection_no: value.collectionNo !== '' ? value.collectionNo : undefined
  }
}
